import React from 'react';
import './CardSMIReview.scss';
import './CardSMIReview-media.scss';
import { ICardSMIReview } from './interfaces';
import { Rating, RoundedStar } from '@smastrom/react-rating';
import '@smastrom/react-rating/style.css';

const CardSMIReview = ({ logo, name, city = '', rating, link }: ICardSMIReview) => {
  const myStyles = {
    itemShapes: RoundedStar,
    activeFillColor: '#FED584',
    inactiveFillColor: 'transparent',
    activeStrokeColor: '#FED584',
    itemStrokeWidth: 1.5,
  };

  return (
    <a
      href={link}
      target="_blank"
      className={`card-smi-review${city === '' ? ' card-smi-review_3' : ''}`}
      rel="nofollow"
    >
      <div className="card-smi-review__logo-block">
        <img src={logo} className="card-smi-review__logo" alt="" />
        <h4 className="card-smi-review__name">{name}</h4>
      </div>
      <p className="body2 card-smi-review__city">{city}</p>
      <h4 className="card-smi-review__rating">{`${rating} / 5`}</h4>
      <Rating
        value={parseFloat(rating.replace(',', '.'))}
        style={{ width: 120, columnGap: '3px' }}
        readOnly
        itemStyles={myStyles}
      />
    </a>
  );
};

export default CardSMIReview;
